import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations } from './translations';

const I18nContext = createContext({ lang: 'fr', setLang: () => {}, t: (k) => k });

const LS_KEY = 'tm_lang';

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'fr';
    return window.localStorage.getItem(LS_KEY) || 'fr';
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(LS_KEY, lang);
      document.documentElement.setAttribute('lang', lang);
    }
  }, [lang]);

  const setLang = useCallback((next) => setLangState(next), []);

  const t = useCallback(
    (path) => {
      const parts = path.split('.');
      let cur = translations[lang];
      for (const p of parts) {
        if (cur && typeof cur === 'object' && p in cur) {
          cur = cur[p];
        } else {
          // fallback to FR
          let fr = translations.fr;
          for (const fp of parts) {
            if (fr && typeof fr === 'object' && fp in fr) fr = fr[fp];
            else return path;
          }
          return fr;
        }
      }
      return cur;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
